// extracted by css-extract-rspack-plugin
export default {"tools-button":"tools-button-mjdCov","toolsButton":"tools-button-mjdCov"};